import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import { buildContentService } from "../services/build_content.services"
import axiosClient from "axios"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"
import { history } from "../helpers/history"
import {
	LOAD_DOCUMENTS_OF_CONCEPT,
	HIDE_ALERT,
	LOGOUT,
	SHOW_ALERT,
	VIEWDOCUMENTS_FIND_DOCUMENTS,
	VIEWDOCUMENTS_SEARCH_ERROR,
	LOAD_CONCEPT_FROM_API,
	VIEWDOCUMENTS_SEARCHING,
	VIEWDOCUMENTS_SET_SOURCE_FILTER,
	VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
	VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
	GET_TARGET_TERMS_OF_CATEGORY,
	LOAD_SEARCH_FROM_API,
	GET_VIEWER_ALL_DOCUMENTS_REQUEST,
	GET_VIEWER_DOCUMENTS_REQUEST_SUCCESS,
	GET_AUDIT_HISTORY,
	GET_ANNOTATION,
	ADD_ANNOTATION,
	DELETE_ANNOTATION,
	DELETE_ANNOTATION_FAILED,
	LOG_AUDIT,
	GET_CHAT,
	POST_CHAT,
} from "../types/index"
import { buildQueryString, clearLocalStorage, payloadParsing, reSortArray, searchTermParse } from "../utils"
import {
	addAnnotationFailed,
	addAnnotationSuccess,
	deleteAnnotationSuccess,
	getAnnotationFailed,
	getAnnotationSuccess,
	getAuditHistoryFailed,
	getAuditHistorySuccess,
	getChatFailed,
	getChatSuccess,
	getViewerAllDocumentsRequestSuccess,
	postChatFailed,
	postChatSuccess,
} from "../actions/viewerActions"
import { setFilterJobId } from "../actions/filterActions"
import { logoutUser } from "../actions/userActions"
import { reviewService } from "../services/review.services"

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`).catch((e) => console.log(e))
}

export const getAuditHistory = (entityId) => {
	return axios.get(
		`/audit/${entityId}/file?limit=100&actions=add_tag&actions=delete_tag&actions=add_comment&actions=delete_comment&actions=update_comment&actions=update_tagged_date`
	)
}

export const getAnnotation = (fileID, pageNumber) => {
	const URL = pageNumber ? `file/annotations?file_id=${fileID}&page_number=${pageNumber}` : `file/annotations?file_id=${fileID}`
	return axios.get(URL).catch((e) => console.log(e))
}

export const getNativeAnnotation = (fileID, pageNumber) => {
	const URL = pageNumber
		? `file/native_annotations?file_id=${fileID}&page_number=${pageNumber}`
		: `file/native_annotations?file_id=${fileID}`
	return axios.get(URL).catch((e) => console.log(e))
}

export const addAnnotation = ({ fileID, pageNumber, start, end, text }) => {
	const URL = `/file/annotations?file_id=${fileID}&page_number=${pageNumber}&start=${start}&end=${end}&text=${encodeURIComponent(text)}`
	return axios.post(URL).catch((e) => console.log(e))
}

export const addNativeAnnotations = ({ note }) => {
	const URL = `/file/native_annotations`
	return axios.post(URL, note).catch((e) => console.log(e))
}

export const deleteAnnotation = (annotationId) => {
	const URL = `/file/annotations?annotation_id=${annotationId}`
	return axios.delete(URL).catch((e) => console.log(e))
}

export const deleteNativeAnnotation = (annotationId) => {
	const URL = `/file/native_annotations?annotation_id=${annotationId}`
	return axios.delete(URL).catch((e) => console.log(e))
}

export const logAuditAPI = (payload) => {
	const URL = `/audit`
	return axios.post(URL, payload).catch((e) => console.log(e))
}

function* logAudit(action) {
	try {
		const result = yield call(logAuditAPI, action?.payload)
	} catch (error) {}
}

export const getChatAPI = (payload) => {
	const URL = `/gen_ai/chat`
	return axios.post(URL, payload).catch((e) => console.log(e))
}

function* loadSearchFromAPIFlow(action) {
	const state = yield select()
	try {
		let response = null
		// if (!action?.payload?.jobIdToRetainData) {
		// 	response = yield call(documentsService.getDocuments, action.payload?.params)
		// } else response = { data: { success: true, job_id: action?.payload?.jobIdToRetainData } }
		// if (response) yield put(setFilterJobId(response?.data?.job_id))
		// let jobId = yield call(getStatusByJobId, response?.data?.job_id)
		const payload = payloadParsing(action.payload?.params)
		if (action.payload?.params?.additional_params?.review_id) {
			const { is_case_admin, review_id, ...restPayload } = payload
			response = yield call(reviewService.getReviewSearch, { review_id, is_case_admin }, restPayload)
		} else {
			response = yield call(documentsService.getDocuments, payload)
		}
		const queryString = buildQueryString(action?.payload?.params)
		//console.log("history", history)
		const url = `${window.location.pathname}?${queryString}`
		history.push(url)
		//yield put(getRetainFiltersSuccess(action.payload.params))

		const ids = response.data.data.map((item) => item.file_id)

		// while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
		// 	yield delay(1000)
		// 	jobId = yield call(getStatusByJobId, response.data.job_id)
		// }

		// if (jobId?.data && jobId.data.job.job_status.success === true) {
		// 	const concept = yield call(documentsService.searchJobId, response.data.job_id)

		// 	const docIdArray = []
		// 	for (var i = 0; i < concept.data.data.data.length; i++) {
		// 		docIdArray.push(`${concept.data.data.data[i].id}`)
		// 	}

		// 	const response_docsData = yield call(documentsService.getFilesMetadata, docIdArray)

		// 	const sortData = reSortArray(docIdArray, response_docsData.data.data)
		// 	let auxData = response_docsData?.data
		// 	if (Array.isArray(response_docsData.data.data)) {
		// 		auxData.data = sortData
		// 		auxData.count = concept.data.data.count
		// 	}
		let contextId, context
		if (action.payload?.additional_params?.review_id) {
			contextId = action.payload?.additional_params?.review_id
			context = CONTEXT_TYPE.REVIEW
		} else if (action.payload?.additional_params?.search_id) {
			contextId = action.payload?.additional_params?.search_id
			context = CONTEXT_TYPE?.SEARCH
		}

		const allDocuments = yield call(documentsService.getFilesMetadata, ids, contextId, context)

		const sortData = reSortArray(ids, allDocuments.data.data)
		let auxData = allDocuments?.data
		if (Array.isArray(allDocuments.data.data)) {
			auxData.data = sortData
			auxData.count = response.data.count
		}
		yield put(getViewerAllDocumentsRequestSuccess(auxData))
		//}
		//yield logAudit(queryString)

		yield put({
			type: HIDE_ALERT,
			payload: null,
		})
	} catch (error) {
		console.log(error)
	}
}

function* getAuditHistoryFlow(action) {
	try {
		const result = yield call(getAuditHistory, action?.payload)

		if (result.status === 200) {
			yield put(getAuditHistorySuccess(result?.data)) //update store
		} else {
			yield put(getAuditHistoryFailed(result))
		}
	} catch (error) {
		yield put(getAuditHistoryFailed(error))
	}
}

function* getAnnotationFlow(action) {
	try {
		let result
		if (action?.payload?.isNativePDF) {
			result = yield call(getNativeAnnotation, action?.payload?.data)
		} else {
			result = yield call(getAnnotation, action?.payload?.data)
		}
		//const result = yield call(getAnnotation, action?.payload?.data)

		if (result?.status === 200) {
			yield put(getAnnotationSuccess(result?.data?.data, action?.payload?.isNativePDF)) //update store
		} else {
			yield put(getAnnotationFailed(result))
		}
	} catch (error) {
		yield put(getAnnotationFailed(error))
	}
}

function* addAnnotationFlow(action) {
	try {
		const result = action?.payload?.isNative
			? yield call(addNativeAnnotations, action?.payload)
			: yield call(addAnnotation, action?.payload)

		if (result?.status === 200) {
			yield put(addAnnotationSuccess(result?.data?.data, action?.payload?.isNative)) //update store
		} else {
			yield put(addAnnotationFailed(result))
		}
	} catch (error) {
		yield put(addAnnotationFailed(error))
	}
}

function* deleteAnnotationFlow(action) {
	try {
		const result = action?.payload?.isNative
			? yield call(deleteNativeAnnotation, action?.payload?.data)
			: yield call(deleteAnnotation, action?.payload?.data)

		if (result?.status === 200) {
			yield put(deleteAnnotationSuccess(result?.data?.data, action?.payload?.isNative)) //update store
		} else {
			yield put(DELETE_ANNOTATION_FAILED(result))
		}
	} catch (error) {
		yield put(DELETE_ANNOTATION_FAILED())
	}
}

function* getChatFlow(action) {
	try {
		const result = yield call(getChatAPI, action?.payload)

		if (result.status === 200) {
			yield put(getChatSuccess(result?.data)) //update store
		} else {
			yield put(getChatFailed(result))
		}
	} catch (error) {
		yield put(getChatFailed(error))
	}
}

function* postChatFlow(action) {
	try {
		const result = yield call(getChatAPI, action?.payload)

		if (result.status === 200) {
			yield put(postChatSuccess(result?.data)) //update store
			try {
				const payload = { file_ids: action?.payload?.file_ids }
				const result = yield call(getChatAPI, payload)

				if (result.status === 200) {
					yield put(getChatSuccess(result?.data)) //update store
				} else {
					yield put(getChatFailed(result))
				}
			} catch (error) {
				yield put(getChatFailed(error))
			}
		} else {
			yield put(postChatFailed(result))
		}
	} catch (error) {
		yield put(postChatFailed(error))
	}
}

function* viewerWatcher() {
	yield takeLatest(GET_VIEWER_ALL_DOCUMENTS_REQUEST, loadSearchFromAPIFlow)
	yield takeLatest(GET_AUDIT_HISTORY, getAuditHistoryFlow)
	yield takeLatest(GET_ANNOTATION, getAnnotationFlow)
	yield takeLatest(ADD_ANNOTATION, addAnnotationFlow)
	yield takeLatest(DELETE_ANNOTATION, deleteAnnotationFlow)
	yield takeLatest(LOG_AUDIT, logAudit)
	yield takeLatest(GET_CHAT, getChatFlow)
	yield takeLatest(POST_CHAT, postChatFlow)
}

export default viewerWatcher
